import type { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';
import { TPO_DELETE_ALL_PROMOTIONS_MODAL } from '../../../config/testIds';
import useDeleteAllPromotionsMutation from '../hooks/mutations/useDeleteAllPromotionsMutation';

const antIconDanger = <LoadingOutlined style={{ fontSize: 16, color: 'red' }} spin />;

export interface DeleteAllPromotionsModalProps {
    open: boolean;
    onClose: () => void;
    planId: string;
    planName: string;
}

const DeleteAllPromotionsModal: FC<DeleteAllPromotionsModalProps> = ({ open, onClose, planId, planName }) => {
    const { mutateAsync: deleteAllPromotions, isPending } = useDeleteAllPromotionsMutation({
        onSuccess: () => {
            onClose();
        },
    });

    return (
        <ConfirmationModal
            data-testid={TPO_DELETE_ALL_PROMOTIONS_MODAL}
            open={open}
            onCancel={onClose}
            onSubmitClick={() => deleteAllPromotions(planId)}
            okText={isPending ? <Spin indicator={antIconDanger} /> : 'Delete'}
            okButtonProps={{ type: 'primary', danger: true, style: { borderRadius: 6 } }}
            loading={isPending}
            title="Delete All Promotions?"
            description={
                <div className="bg-[#fafafa] rounded-lg p-2">
                    <p className="text-sm text-[#18181b]">{`This will remove all the promotions in ${planName || planId}.`}</p>
                </div>
            }
            width={520}
        />
    );
};

DeleteAllPromotionsModal.displayName = 'DeleteAllPromotionsModal';
export default DeleteAllPromotionsModal;
